import popularRecipes from "../data/popular-recipes.json";

export type PreviewRecipe = {
  mainRecipeId: number | null;
  recipeId: number;
  recipeName: string;
  cookingTimeMax: number;
  cookingTimeMin: number;
  shelfLife: number | null;
  images: {
    urls: {
      size: string;
      url: string;
    }[];
  };
  taxonomies: {
    taxonomyId: number;
    name: string;
    description: string;
    order: number;
    type: string;
  }[];
};

export type PopularRecipeEntry = {
  week: number;
  year: number;
  conceptPreferenceIds: string[];
  tastePreferenceIds: string[];
  recipes: PreviewRecipe[];
};

type GetPopularPreviewRecipesArgs = {
  week: number;
  year: number;
  conceptPreferenceIds: string[];
  tastePreferenceIds: string[];
};

const findEntry = (
  entryPreferenceIds: string[],
  selectedPreferenceIds: string[],
) => {
  if (entryPreferenceIds.length !== selectedPreferenceIds.length) {
    return false;
  }

  return entryPreferenceIds.every((id) => selectedPreferenceIds.includes(id));
};

export const getPopularPreviewRecipes = ({
  week,
  year,
  conceptPreferenceIds,
  tastePreferenceIds,
}: GetPopularPreviewRecipesArgs): PreviewRecipe[] => {
  const data: PopularRecipeEntry[] = popularRecipes.data;

  if (data.length === 0) {
    console.error("Popular recipes data is empty");
    return [];
  }

  let entry: PopularRecipeEntry = data[0];

  if (week && year) {
    const foundEntry = data.find(
      (d) =>
        d.week === week &&
        d.year === year &&
        findEntry(d.conceptPreferenceIds, conceptPreferenceIds) &&
        findEntry(d.tastePreferenceIds, tastePreferenceIds),
    );

    // If no entry is found, we will fetch the recipes on the client side on demand
    if (!foundEntry) {
      return [];
    }

    entry = foundEntry;
  }

  return entry.recipes;
};
